import React, { Component } from "react";
import { connect } from "react-redux";
import { PageHeader, Tooltip, Tag, Progress, message } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { ButtonItem, SegmentedItem, TableItemDinamico, TourItem } from "../../../../Components/Items";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import { cmmsPost, formatoFecha, formatoMoneda } from "../cmmsComun";
import "../cmms.css";

// Contratos de mantenimiento (lo que hoy lleva el C-SE-03): vigencia, alerta de renovacion,
// cobro, equipos y avance del programa.
class Contratos extends Component {
    refFiltros = React.createRef();
    refTabla = React.createRef();
    state = { loading: false, contratos: [], totalRecords: 0, valor: 1, clienteId: null, openTour: false };

    consultar = async (params) => {
        this.setState({ loading: true });
        try {
            const res = await cmmsPost(this.props, "selectContratosCMMS", params);
            if (res.data.success === 2) this.setState({ contratos: res.data.data, totalRecords: res.data.totalRecords });
            else this.setState({ contratos: [], totalRecords: 0 });
        } catch (error) {
            console.log(error);
            message.error("Error al consultar los contratos");
        } finally {
            this.setState({ loading: false });
        }
    };

    aplicarFiltros = (cambios) =>
        this.setState(cambios, () =>
            this.tableRef?.updateExternalFilters({ ...(this.tableRef.state?.externalFilters || {}), valor: this.state.valor, clienteId: this.state.clienteId })
        );

    abrir = (id) => this.props.history.push("/panel/cmmsContrato", { id });

    render() {
        const columns = [
            { title: "Folio", dataIndex: "codigo", key: "codigo", buscar: "codigo", sorter: true, width: 100 },
            { title: "ID de contrato", dataIndex: "idContrato", key: "idContrato", buscar: "idContrato", sorter: true, width: 160 },
            { title: "Cliente", dataIndex: "clienteNombre", key: "clienteNombre", buscar: "clienteNombre", sorter: true, width: 230 },
            { title: "Tipo", dataIndex: "tipoContrato", key: "tipoContrato", buscar: "tipoContrato", width: 170 },
            { title: "Inicio", dataIndex: "fechaInicio", key: "fechaInicio", sorter: true, width: 110, render: (v) => formatoFecha(v) },
            { title: "Término", dataIndex: "fechaConclusion", key: "fechaConclusion", sorter: true, width: 110, render: (v) => formatoFecha(v) },
            {
                title: "Estatus",
                dataIndex: "estatusNombre",
                key: "estatusNombre",
                width: 160,
                render: (v, r) => (
                    <span>
                        <Tag color={r.estatusColor}>{v}</Tag>
                        {r.diasRestantes !== null && r.diasRestantes >= 0 && r.estatusClave !== "cancelado" ? <span style={{ fontSize: 12, color: "#7a8794" }}>{r.diasRestantes} días</span> : null}
                    </span>
                ),
            },
            { title: "Valor", dataIndex: "valor", key: "valor", width: 120, render: (v, r) => (r.valorVariable ? "Variable" : formatoMoneda(v)) },
            { title: "Esquema de cobro", dataIndex: "esquemaCobroNombre", key: "esquemaCobroNombre", width: 190, render: (v, r) => `${v}${r.cobroMensual ? ` · ${formatoMoneda(r.cobroMensual)}` : ""}` },
            { title: "Equipos", dataIndex: "equipos", key: "equipos", width: 85, align: "right" },
            {
                title: "Avance",
                dataIndex: "avance",
                key: "avance",
                width: 150,
                render: (v, r) =>
                    r.programados ? (
                        <Tooltip title={`${r.realizados} de ${r.programados} servicios del programa`}>
                            <Progress percent={Math.round((v || 0) * 100)} size="small" />
                        </Tooltip>
                    ) : (
                        <span style={{ color: "#9aa7b4" }}>Sin programa</span>
                    ),
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                fixed: "right",
                align: "center",
                width: 80,
                onCell: () => ({ className: "acciones-sin-hover", style: { textAlign: "center", padding: "4px" } }),
                render: (value) => (
                    <Tooltip title="Abrir">
                        <ButtonItem type="default" size="small" cyan icon={<EditOutlined />} onClick={() => this.abrir(value._id)} />
                    </Tooltip>
                ),
            },
        ];
        return (
            <>
                <PageHeader
                    title="Contratos"
                    subTitle="Contratos de mantenimiento con clientes"
                    style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
                    extra={
                        <>
                            <SegmentedItem
                                options={[
                                    { label: "Vigentes", value: 1 },
                                    { label: "Por renovar", value: 2 },
                                    { label: "Vencidos", value: 3 },
                                    { label: "Cancelados", value: 4 },
                                    { label: "Todos", value: 5 },
                                ]}
                                value={this.state.valor}
                                onChange={(valor) => this.aplicarFiltros({ valor })}
                            />
                            <ButtonItem type="primary" olivo className="botonAgregar" onClick={() => this.props.history.push("/panel/cmmsContrato", {})}>
                                Nuevo Contrato
                            </ButtonItem>
                            <ButtonItem type="link" blanco onClick={() => this.setState({ openTour: true })}>
                                ¿Cómo funciona?
                            </ButtonItem>
                        </>
                    }
                />
                <div className="cmms-filtros" ref={this.refFiltros}>
                    <div style={{ width: 300 }}>
                        <SelectClientesItem
                            empresaId={this.props.empresaId}
                            headersToken={this.props.headersToken}
                            placeholder="Todos los clientes"
                            allowClear
                            width="100%"
                            value={this.state.clienteId || undefined}
                            onChange={(clienteId) => this.aplicarFiltros({ clienteId: clienteId || null })}
                        />
                    </div>
                </div>
                <div ref={this.refTabla}>
                    <TableItemDinamico
                        onRef={(ref) => (this.tableRef = ref)}
                        totalRecords={this.state.totalRecords}
                        anadirValorFiltro={this.state.valor}
                        valorDefault={1}
                        setValor={(valor) => this.setState({ valor })}
                        setTextoFiltro={() => {}}
                        onFetchData={this.consultar}
                        loading={this.state.loading}
                        size="small"
                        dataSource={this.state.contratos}
                        columns={columns}
                        pagination={false}
                        rowKey="_id"
                        filterStorageKey={"ContratosCMMSFiltrosTabla" + this.props.empresaId}
                        onRow={(r) => ({ onDoubleClick: () => this.abrir(r._id) })}
                    />
                </div>
                <TourItem
                    open={this.state.openTour}
                    onClose={() => this.setState({ openTour: false })}
                    steps={[
                        {
                            title: "Contratos",
                            description:
                                "Cada contrato define el cliente, la vigencia, el cobro y sus vueltas (periodos de atención, ej. 1ra Vuelta marzo–mayo). Sus equipos son los activos que usted le agrega.",
                            target: null,
                        },
                        {
                            title: "Estatus automático",
                            description: "Vigente, Por renovar (días antes del fin configurables en el contrato, 30 por defecto) y Vencido se calculan solos con las fechas.",
                            target: () => this.refTabla.current,
                        },
                        {
                            title: "Avance",
                            description: "Servicios realizados contra los programados en todas las vueltas. El detalle por vuelta, mes, sucursal e ingeniero está en el paso Progreso del contrato.",
                            target: () => this.refTabla.current,
                        },
                    ]}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(Contratos);
